import { IVin } from 'types/carrier'

export const getVinErrors = (
  vin: string,
  currentVins: IVin[],
  criteria: {},
  errorMessages: {}
): string[] | undefined => {
  const errors: string[] = []
  let test
  for (const criterion in criteria) {
    if (criterion) {
      test = criteria[criterion as keyof typeof criteria] as Function
      if (test(vin, currentVins))
        errors.push(errorMessages[criterion as keyof typeof errorMessages])
    }
  }
  return errors.length ? errors : undefined
}
